import clsx from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  color?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export const LoadingSpinner = ({ size = 'md', className, color = 'blue' }: LoadingSpinnerProps) => {
  return (
    <div className={clsx('flex justify-center items-center', className)}>
      <div
        className={clsx(
          `animate-spin rounded-full border-b-2 border-${color}-600`,
          sizeClasses[size]
        )}
      />
    </div>
  );
};
